import React, { memo } from "react";
import { Source, Layer } from "react-map-gl";
import { IField } from "../../types/fieldInterface";

interface Props {
  field: IField;
  isFocused?: boolean;
}

const RenderPolygonComponent: React.FC<Props> = ({ field, isFocused = false }) => {
  if (!field.area) return null;

  const geojson = {
    type: "FeatureCollection",
    features: Object.values(field.area).map((area: any) => ({
      ...area,
      type: "Feature",
      geometry: { ...area.geometry, type: "Polygon" },
    })),
  };

  return (
    <Source id={`field-${field.id}`} type="geojson" data={geojson as any}>
      <Layer
        id={`field-fill-${field.id}`}
        type="fill"
        paint={{
          "fill-color": "#088",
          "fill-opacity": isFocused ? 0.22 : 0.14,
        }}
      />
      <Layer
        id={`field-line-${field.id}`}
        type="line"
        paint={{
          "line-color": "#088",
          "line-width": isFocused ? 5 : 2,
        }}
      />
    </Source>
  );
};

export default memo(RenderPolygonComponent, (prev, next) => {
  return (
    prev.field.id === next.field.id &&
    prev.field.area === next.field.area &&
    prev.isFocused === next.isFocused
  );
});
